import "./EdocsHomePage.css"
import BottomBar from "../BottomBar/bottombar"
import {
  info,
  arrowDownRight,
  arrowTopRight,
  successThumb,
  pdfIcon
} from "../../images"
import { useState } from "react"
import { apiEndPoints } from "constants/apiEndpoints"
import { useSelector } from "react-redux"
import { RootState } from "store/store"
import { http } from "utils/http"
import { toast } from "react-toastify"
import { useTimer } from "react-timer-hook"
import { useTranslation } from "react-i18next"

const SMSTimer = ({ expiryTimestamp }: any) => {
  const { t } = useTranslation()
  const [smsButtonEnable, setSmsButtonEnable] = useState(false)
  const visitObj = useSelector(
    (state: RootState) => state.visitReducer.visit?.visit
  )
  const appointmentDetails = useSelector(
    (state: RootState) => state.appointmentReducer.appointment?.details
  )
  const smsMatchingVisitDetails = useSelector(
    (state: RootState) =>
      state.appointmentReducer.appointment?.smsMatchingVisitDetails
  )
  const isNewSession = useSelector(
    (state: RootState) => state.appointmentReducer.appointment?.isNewSession
  )
  const sendMessage = () => {
    setSmsButtonEnable(false)
    const time = new Date()
    time.setSeconds(time.getSeconds() + 30)
    restart(time)
    let visitId = smsMatchingVisitDetails?.id || visitObj?.visit?.id
    if (
      isNewSession &&
      !smsMatchingVisitDetails?.status.includes("completed")
    ) {
      visitId = visitObj?.visit?.id
    }
    const stopType = appointmentDetails[0]?.direction
    http
      .post(
        `${apiEndPoints.resendNotification}`,
        {
          visitId: visitId,
          stopType: stopType === "outbound" ? "pickup" : "delivery"
        },
        {}
      )
      .then(() => {
        toast.success("SMS sent successfully")
      })
      .catch(err => toast.error(err.response.data.error))
  }
  const { seconds, minutes, isRunning, restart } = useTimer({
    expiryTimestamp,
    onExpire: () => {
      setSmsButtonEnable(true)
    }
  })

  return (
    <div style={{ textAlign: "center", width: "100%" }}>
      <BottomBar
        onClick={sendMessage}
        disabled={!smsButtonEnable}
        className={
          smsButtonEnable
            ? "whiteBorderedBtn widthfull"
            : "widthfull whiteBorderedBtnDisable"
        }
        text={t("resend_sms")}
      />
      <div>
        {isRunning ? (
          <span>
            {t("resend_sms_in")} <span>0{minutes}</span>:
            <span>{seconds < 10 ? `0${seconds}` : `${seconds}`}</span>
          </span>
        ) : null}
      </div>
    </div>
  )
}
export default SMSTimer
